import React, { useEffect } from 'react';

const AdBanner = ({
  dataClient = 'ca-pub-4123099254464103',
  dataSlot = '8888566584'
}) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      // console.log(err);
    }
  }, []);

  return (
    <>
      <ins
        className='adsbygoogle adbanner-customize'
        style={{
          display: 'block'
        }}
        data-ad-client={dataClient}
        data-ad-slot={dataSlot}
        data-ad-format='auto'
        data-full-width-responsive='true'
      />
    </>
  );
};

export default AdBanner;
